import { getConfigByCountry, getCurrencySymbolPosition as _getCurrencySymbolPosition } from './config';
import { deflateServerNumber as _deflateServerNumber, parseServerNumber as _parseServerNumber } from './convertNumber';
import * as FormatCurrency from './formatCurrency';
import * as CompactNumber from './compactNumber';
import * as FormatNumber from './formatNumber';
export * from './constants';
export * from './config';
export * from './convertNumber';
export * from './formatNumber';
export * from './formatCurrency';
export * from './compactNumber';
export { getNumberParts } from './utils';
export function getUtilsByCountry(country, language) {
  var Config = getConfigByCountry(country, language);
  return {
    getCurrencyConfig: function getCurrencyConfig() {
      return Config.getCurrencyConfig(country);
    },
    getCountryConfig: function getCountryConfig() {
      return Config.getCountryConfig(country, language);
    },
    deflateServerNumber: function deflateServerNumber(input) {
      return _deflateServerNumber(input, country);
    },
    parseServerNumber: function parseServerNumber(input) {
      return _parseServerNumber(input, country);
    },
    getCurrencySymbol: function getCurrencySymbol() {
      return Config.getCurrencySymbol(country);
    },
    getCurrencySymbolPosition: function getCurrencySymbolPosition() {
      return _getCurrencySymbolPosition(country);
    },
    getNotches: function getNotches() {
      return Config.getNotches(country, language);
    },
    formatServerNumber: function formatServerNumber(input, options) {
      return FormatNumber.formatNumber(_deflateServerNumber(input, country), options);
    },
    formatCurrencyNumber: function formatCurrencyNumber(input, options) {
      return FormatCurrency.formatCurrencyNumber(country, input, options);
    },
    formatServerCurrencyNumber: function formatServerCurrencyNumber(input, options) {
      return FormatCurrency.formatCurrencyNumber(country, _deflateServerNumber(input, country), options);
    },
    formatCurrency: function formatCurrency(input, options) {
      return FormatCurrency.formatCurrency(country, input, options);
    },
    formatServerCurrency: function formatServerCurrency(input, options) {
      return FormatCurrency.formatCurrency(country, _deflateServerNumber(input, country), options);
    },
    compactServerNumber: function compactServerNumber(input, maxPrecision, notches) {
      return CompactNumber.compactNumber(_deflateServerNumber(input, country), maxPrecision, notches);
    },
    localizeCompactNumber: function localizeCompactNumber(input, options) {
      return CompactNumber.localizeCompactNumber(country, input, options, language);
    },
    localizeCompactServerNumber: function localizeCompactServerNumber(input, options) {
      return CompactNumber.localizeCompactNumber(country, _deflateServerNumber(input, country), options, language);
    },
    compactCurrency: function compactCurrency(input, options, notches) {
      return CompactNumber.compactCurrency(country, input, options, notches, language);
    },
    compactServerCurrency: function compactServerCurrency(input, options, notches) {
      return CompactNumber.compactCurrency(country, _deflateServerNumber(input, country), options, notches, language);
    }
  };
}
export default getUtilsByCountry;